export default "__VITE_ASSET__95eaffb8__"